<footer>
  <div class="cfb">
    <div
      fxLayout="row"
      fxLayout.xs="column"
      fxLayoutAlign="center center"
      fxLayoutAlign.xs="left top"
      fxLayoutGap="2rem"
      fxLayoutGap.xs="0rem"
    >
      <div class="login__footerLinks" data-test-id="rights-reserved-lbl">
        <small>
          &copy; {{ currentYear }} {{ 'footer.copyRight' | translate }}</small
        >
      </div>
      <div class="login__footerLinks">
        <div
          fxLayout="row"
          fxLayoutAlign="center center"
          fxLayoutAlign.xs="left top"
          fxLayoutGap="2rem"
        >
          <a
            data-test-id="privacy-policy-link"
            target="_blank"
            href="https://www.cigna.com/legal/compliance/privacy-notices"
            rel="noopener noreferrer"
            >{{ 'footer.privacy' | translate }}
            <cigna-icon
              type="external-link"
              class="cg-mat-icon-link-right cg-color-digital-blue f-s-m"
            ></cigna-icon>
          </a>
          <a
            data-test-id="legal-disclaimer-link"
            target="_blank"
            [href]="'https://www.cigna.com/legal/compliance/disclaimers'"
            >{{ 'footer.legalDisclaimer' | translate }}
            <cigna-icon
              type="external-link"
              class="cg-mat-icon-link-right cg-color-digital-blue f-s-m"
            ></cigna-icon>
          </a>
        </div>
      </div>
    </div>
    <div fxLayout="column" class="footer-text">
      <div *ngIf="isDivestEnabled" class="margin-bottom-sm">
        <b class="broker-use-only">{{ 'footer.broker.terms9' | translate }}</b>
        <p>{{ 'footer.broker.terms10' | translate }}</p>
        <p>
          <cigna-icon
            type="external-link"
            class="cg-mat-icon-link-right"
          ></cigna-icon>
          {{ 'footer.broker.terms11' | translate }}
        </p>
        <p>
          {{ 'footer.broker.terms12' | translate }}
        </p>
      </div>
      <div *ngIf="!isDivestEnabled">
        <p>
          {{ 'footer.broker.terms1' | translate }}
        </p>
        <p>
          {{ 'footer.broker.terms2' | translate }}
        </p>
        <p>
          {{ 'footer.broker.terms3' | translate }}
        </p>
        <p>
          {{ 'footer.broker.terms4' | translate }}
        </p>
        <p>
          <cigna-icon
            type="external-link"
            class="cg-mat-icon-link-right"
          ></cigna-icon>
          {{ 'footer.broker.terms5' | translate }}
        </p>
        <p>
          {{ 'footer.broker.terms12' | translate }}
        </p>
      </div>
    </div>
  </div>
</footer>
